import { Box, Table as TableCore } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Table as TableCollapsable } from '../../../../../../../components/table-collapsable';
import { DegreeProcessActivity, DegreeProcessRenditionRow } from '../types';
import { useColumns } from './useColumns';
import { useColumnsRenditions } from './useColumnsRenditions';
import { Col, Row } from 'reactstrap';

export interface TableProps {
  data: DegreeProcessActivity[];
  gradeAverage: number;
}

export default function Table({ data, gradeAverage }: TableProps) {
  const { t } = useTranslation();
  const columnsRenditions = useColumnsRenditions();
  const columns = useColumns();

  return (
    <>
      <TableCollapsable<DegreeProcessActivity>
        columns={columns}
        secondColumn={{
          tdClassName: 'px-4',
          columnName: 'quota',
          headerText: t(`table.quota`),
          cellFormat: ({ row }) => {
            return (
              <TableCore<DegreeProcessRenditionRow>
                key={`renditions-${row.id}`}
                borderless={false}
                color="transparent"
                striped
                columns={columnsRenditions}
                data={row.renditions}
              />
            );
          },
        }}
        data={data}
      />
      <Box
        body={
          <Row className="justify-content-end pr-4">
            <Col xs="auto" className="font-weight-bold">
              {t('studentsDegreeStudent.tableActivities.gradeAverage')}
              <span> {gradeAverage > 0 ? gradeAverage : 'N/A'}</span>
            </Col>
          </Row>
        }
        color="secondary"
        title=""
        variant="standard"
        fullwidth
      />
    </>
  );
}
